import React from 'react';

type Link = {
  label: string;
  href: string;
};

const techLinks: Link[] = [
  {
    label: 'Hacker News – Front Page',
    href: 'https://news.ycombinator.com/',
  },
  {
    label: '.NET Blog',
    href: 'https://devblogs.microsoft.com/dotnet/',
  },
  {
    label: 'AWS Compute Blog',
    href: 'https://aws.amazon.com/blogs/compute/',
  },
  {
    label: 'React Core Blog',
    href: 'https://react.dev/blog',
  },
];

const TechFeedWidget: React.FC = () => {
  return (
    <div className="terminal-panel flex flex-col justify-between rounded-2xl border border-slate-800/80 p-4 text-xs text-slate-200">
      <div>
        <div className="flex items-center justify-between">
          <span className="text-[11px] uppercase tracking-[0.2em] text-slate-400">Tech feed</span>
          <span className="rounded-full bg-slate-800 px-2 py-0.5 text-[10px] font-medium uppercase tracking-[0.16em] text-slate-300">
            Curated
          </span>
        </div>
        <p className="mt-2 text-[11px] text-slate-400">
          A few places I check regularly to stay current on platforms and patterns I build with.
        </p>
      </div>
      <ul className="mt-3 space-y-2">
        {techLinks.map((link) => (
          <li key={link.href}>
            <a
              href={link.href}
              target="_blank"
              rel="noreferrer"
              className="flex items-center justify-between rounded-lg border border-slate-800/80 bg-slate-900/80 px-3 py-2 text-[11px] text-slate-100 transition hover:border-emerald-400/70 hover:bg-slate-900"
            >
              <span className="truncate">{link.label}</span>
              <span className="ml-2 text-[13px] text-slate-500">↗</span>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TechFeedWidget;

